import axios from 'axios';

const hubId = window._infl.hub.id;
const hubUrl = window.location.origin;
const csrfToken = () => {
  const element = document.querySelector('meta[name=csrf-token]');
  return element ? element.content : null;
};

const hub = axios.create({
  baseURL: hubUrl,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    X_ORG_ID: hubId,
    X_CSRF_Token: csrfToken()
  }
});

const levelsUrl = '/corporate/settings/levels';
const sendCreate = data => hub.post(levelsUrl, data);
const sendUpdate = (level_id, data) => hub.put(`${levelsUrl}/${level_id}`, data);

const buildInitialLevel = (level, existingLevels) =>
  R.pipe(
    R.assoc('name', buildLevelName(level, existingLevels)),
    R.assoc('required_badge_count', level['required-badge-count'])
  )(level);

export const sendData = data => data.id ? sendUpdate(data.id, data) : sendCreate(data);

export const buildLevelName = (level, existingLevels) => (
  level.name || R.pipe(
    R.filter(R.pipe(R.prop('name'), R.test(/new level/i))),
    R.length,
    count => `New Level${count > 0 ? '#' : ''}`
  )(existingLevels)
);

export const buildLevels = (level, existingLevels) =>
  level.uuid ? existingLevels : [...existingLevels, { ...level, current: true }];

export const buildSelectedBadges = (level, allBadges) =>
  level.uuid
    ? R.pipe(
      R.filter(R.propEq('level-id', level.id)),
      R.map(R.prop('id')),
      R.map(R.objOf(R.__, true)),
      R.mergeAll
    )(allBadges)
    : {};

export const buildErrorMessage = R.pipe(Array.of, R.join(', '));

export const buildInitialState = (level, existingLevels, allBadges) =>
  R.pipe(
    R.assoc('form', buildInitialLevel(level, existingLevels)),
    ({ form }) => ({
      form,
      levels: buildLevels(form, existingLevels),
      selectedBadges: buildSelectedBadges(form, allBadges),
      errors: {},
    })
  )({});

export const selectFormData = ({ form, levels, selectedBadges }) => ({
  id: form.id,
  level: {
    name: form.name,
    required_badge_count: form.required_badge_count
  },
  selected_badges_ids: R.keys(selectedBadges),
  levels: levels.map((level, index) => ({
    code: level.code,
    rank: R.inc(index)
  }))
});

export const saveButtonStatusSelector = ({ errors, isSaving }) =>
  R.cond([
    [R.always(R.not(R.isEmpty(errors))), R.always('error')],
    [R.always(isSaving), R.always('pending')],
    [R.T, R.always('default')]
  ])();

